import React from 'react'
import SubTitle from '../common/SubTitle'
import DataBackup from './DataBackup'
import ImportExport from './ImportExport'
import DeleteData from './DeleteData'

export default function ManageDataMain() {
    return (
        <>
            <SubTitle
                title="manageData"
                path="organization > manageData"
            />
            <DataBackup />
            <ImportExport />
            <DeleteData />
        </>
    )
}
